import React from 'react';
import styled from 'styled-components';

import { eventUserStatuses } from 'lib/enums/eventUserStatuses';
import { statusObject } from 'pages/SchedulePage/utils/statusObject';

const STitle = styled('span')`
  font-size: 12px;
  font-weight: 600;
  color: ${(props) => props.disabled ? props.theme.palette.colors.white : props.theme.palette.colors.black100};
`;

const STime = styled('div')`
  //display: flex;
  width: 100%;
  align-items: center;
  font-size: 12px;
  font-weight: 500;
  color: ${(props) => props.disabled ? props.theme.palette.colors.white : props.theme.palette.colors.black100};
  margin-right: 3px;
  svg {
    font-size: 20px;
  }
`;

const SContainer = styled('div')`
  && {
    border-radius: 4px;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 12px;
    height: 100%;
    padding: ${({ isSelected }) =>
      isSelected ? '3px' : '5px'}; // discount border width
    background-color: ${({ backgroundColor }) => backgroundColor};
    border: ${({ isSelected, borderColor }) =>
      isSelected ? `2px solid ${borderColor}` : 'none'};
  }
`;

const SAbsence = styled('div')`
  background: repeating-linear-gradient(
    135deg,
    ${({theme}) => theme.palette.colors.blue200},
    ${({theme}) => theme.palette.colors.blue200} 14px,
    ${({theme}) => theme.palette.colors.white} 14px,
    ${({theme}) => theme.palette.colors.white} 28.5px,
    ${({theme}) => theme.palette.colors.blue200} 28.5px,
    ${({theme}) => theme.palette.colors.blue200} 42px,
    ${({theme}) => theme.palette.colors.white} 42px,
    ${({theme}) => theme.palette.colors.white} 56.5px
  );
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 5px;
  height: 100%;
`;

const SUserName = styled('div')`
  font-size: 12px;
  font-weight: 500;
  color: ${(props) => props.disabled ? props.theme.palette.colors.white : props.theme.palette.colors.black100};
  overflow: hidden;
  text-overflow: ellipsis;
`;

const SNote = styled('div')`
  font-size: 12px;
  font-weight: 400;
  color: ${(props) => props.disabled ? props.theme.palette.colors.white : props.theme.palette.colors.black100};
`;

export { SContainer, STime, STitle, SAbsence, SUserName, SNote };
